import { render } from "./Translate.vue.js?vue&type=template&id=d1fd637c!=!../vue-loader/dist/index.js??ruleSet[0]!./Translate.vue?vue&type=template&id=d1fd637c"
import script from "./Translate.vue.js?vue&type=script&lang=js!=!../vue-loader/dist/index.js??ruleSet[0]!./Translate.vue?vue&type=script&lang=js"
export * from "./Translate.vue.js?vue&type=script&lang=js!=!../vue-loader/dist/index.js??ruleSet[0]!./Translate.vue?vue&type=script&lang=js"

import exportComponent from "../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__